export default __webpack_public_path__ + "static/media/hotel_1.2f7139ca.jpg";